var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeam = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-41 -739) translate(15 657) translate(17 74) translate(9 8) translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.926,
  cy: 8.148,
  r: 3.386
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.701,
  cy: 3.386,
  r: 3.386
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.062 20H.79c-.436 0-.79-.313-.79-.698v-3.184c0-2.531 2.323-4.584 5.188-4.584h1.475c2.866 0 5.189 2.053 5.189 4.584v3.184c0 .385-.354.698-.79.698z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.012 15.238h-6.857c-.437 0-.79-.312-.79-.698v-3.184c0-2.531 2.322-4.584 5.188-4.584h1.475c1.397 0 2.666.489 3.599 1.282",
  transform: "matrix(-1 0 0 1 28.991 0)"
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeam);
export default ForwardRef;